<template>
  <div>
    <Content>
      <template #body>
        <div v-if="isCreatePage" class="users-disclaimer">
          <p>
            ВАЖНО! У полевых сотрудников SR SV аккаунты обезличены. Чтобы
            передать новому сотруднику аккаунт, нужно сбросить пароль для уже
            существующего аккаунта с конкретным маршрутом!
          </p>
          <p>
            ЗАПРЕЩЕНО использовать ФИО и email сотрудников при создании любых
            аккаунтов (запрет на любые персональные данные).
          </p>
        </div>
        <Form
          :scheme="scheme"
          :method-fetch-data="methods.fetchData"
          :method-create-data="methods.createData"
          :method-update-data="methods.updateData"
          :method-update-scheme="methods.updateScheme"
          :additional-validation-rules="additionalValidationRules"
        />
      </template>
    </Content>
    <el-dialog
      :visible.sync="dialogVisible"
      width="400px"
      title="Временный пароль"
      @close="$emit('close')"
    >
      <CopyInput :text="text" />
      <p style="word-break: break-word">
        Скопируйте временный пароль. Он отображается один раз и станет
        недоступен после закрытия окна.
      </p>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirm">Закрыть</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Content from "@/layout/Content";
import Form from "@/components/Form";
import store from "@/store";
import router from "@/router";

import {
  getUserById as fetchData,
  createUser as createData,
  updateUser as updateData,
} from "@/api/users";
import { enumUserRoles, enumUserRolesAdminRegion } from "@/utils/filters";
import defaultScheme from "@/api/schemes/users";
import addCollectionsToScheme from "@/utils/addCollectionsToScheme";
import CopyInput from "@/components/CopyInput.vue";

const updateScheme = async (scheme) => {
  if (window.location.pathname.includes("edit")) {
    delete scheme.properties.password;
    delete scheme.required.password;
  }

  // Todo: utils with promise all
  try {
    const { roles } = scheme.properties;
    const isAdminRegion =
      store.getters.roles?.length && store.getters.roles[0] === "adminregion";
    const items = isAdminRegion ? enumUserRolesAdminRegion : enumUserRoles;

    Object.assign(roles, {
      items,
      params: { key: "id", label: "name", multiple: true },
    });

    scheme = await addCollectionsToScheme(scheme);
  } catch (err) {
    console.log(err);
  }
  return scheme;
};

export default {
  components: {
    Content,
    Form,
    CopyInput,
  },
  computed: {
    isCreatePage() {
      return this.$route.path.includes("/users/create");
    },
  },
  data() {
    return {
      scheme: defaultScheme,
      methods: {
        async fetchData(userId) {
          const user = await fetchData(userId);
          user.roles = enumUserRoles.filter((r) => user.roles.includes(r.id));
          return user;
        },
        createData: async (data) => {
          data.roles = data.roles.map((r) => r.id);
          this.response = await createData(data);

          if (!this.response) return;

          if (this.response.temp_password) {
            // показываем модальное окно
            this.dialogVisible = true;
            this.text = this.response.temp_password;
          } else if (this.response.id) {
            // редиректим на страницу редактирования регионов
            this.goToEditRegion();
          }

          return this.response;
        },
        async updateData(state, data) {
          if (data.roles) {
            data.roles = data.roles.map((r) => r.id);
          }
          return await updateData(state, data);
        },
        updateScheme,
      },
      additionalValidationRules: {
        email() {
          return {
            validator: (rule, value, callback) => {
              const roles = Array.isArray(this.form.roles)
                ? this.form.roles
                : [];
              const hasContractorRole = roles.some((role) => {
                if (typeof role === "string") {
                  return role === "contractor";
                }
                return role?.id === "contractor";
              });
              const email = typeof value === "string" ? value.trim() : value;

              if (hasContractorRole && !email) {
                callback(new Error("Пожалуйста, заполните это поле."));
                return;
              }

              callback();
            },
            trigger: ["blur", "change"],
          };
        },
      },
      dialogVisible: false,
      text: "",
      response: null,
    };
  },
  methods: {
    async confirm() {
      // После закрытие модалки, редиректим на страницу редактирования регионов
      await this.goToEditRegion();
    },
    async goToEditRegion() {
      // редиректим на страницу редактирования регионов
      if (!this.response?.id) return;
      await router.push(`/users/edit/${this.response.id}/regions/append/`);
    },
  },
};
</script>

<style scoped>
.users-disclaimer {
  margin-bottom: 16px;
  padding: 12px 16px;
  background-color: #fff7e6;
  border: 1px solid #f5d8a8;
  border-radius: 4px;
}

.users-disclaimer p {
  margin: 0;
  line-height: 1.5;
}

.users-disclaimer p + p {
  margin-top: 8px;
}
</style>
